<template>
    <div class="wrapper wrapper-content animated fadeInRight">
        <div class="row">
            <div class="col-lg-12">
                <div class="ibox float-e-margins">
                    <div class="ibox-title">
                        <h5>Detalhes da Não Conformidade</h5>
                        <div class="ibox-tools">
                            <button v-if="nonconformity.status !== 'Fechado'" @click="closeNonconformity" class="btn btn-success btn-xs mr-2" :disabled="loading">
                                <i v-if="closingNonconformity" class="fa fa-spinner fa-spin"></i>
                                Fechar Não Conformidade
                            </button>
                            <router-link :to="'/nonconformities'" class="btn btn-primary btn-xs">
                                Voltar
                            </router-link>
                        </div>
                    </div>
                    <div class="ibox-content">
                        <div v-if="loading" class="text-center">
                            <i class="fa fa-spinner fa-spin fa-3x"></i>
                            <p>Carregando...</p>
                        </div>
                        <div v-else>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>ID:</label>
                                        <p>{{ nonconformity.id }}</p>
                                    </div>
                                    <div class="form-group">
                                        <label>Unidade:</label>
                                        <p>{{ nonconformity.branch ? nonconformity.branch.name : 'N/A' }}</p>
                                    </div>
                                    <div class="form-group">
                                        <label>Área:</label>
                                        <p>{{ nonconformity.team ? nonconformity.team.name : 'N/A' }}</p>
                                    </div>
                                    <div class="form-group">
                                        <label>Usuário:</label>
                                        <p>{{ nonconformity.user ? nonconformity.user.name : 'N/A' }}</p>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Data de Criação:</label>
                                        <p>{{ formatDate(nonconformity.created_at) }}</p>
                                    </div>
                                    <div class="form-group">
                                        <label>Status:</label>
                                        <p>
                                            <span :class="getStatusClass(nonconformity.status)">
                                                {{ nonconformity.status || 'Pendente' }}
                                            </span>
                                        </p>
                                    </div>
                                    <div class="form-group" v-if="nonconformity.closed_at">
                                        <label>Fechado em:</label>
                                        <p>{{ formatDate(nonconformity.closed_at) }}</p>
                                    </div>
                                    <div class="form-group" v-if="nonconformity.closed_by">
                                        <label>Fechado por:</label>
                                        <p>{{ nonconformity.closed_by ? nonconformity.closed_by.name : 'N/A' }}</p>
                                    </div>
                                    <div class="form-group">
                                        <label>Checklist:</label>
                                        <p>{{ nonconformity.checklist ? nonconformity.checklist.name : 'N/A' }}</p>
                                    </div>
                                    <div class="form-group">
                                        <label>Item do Checklist:</label>
                                        <p>{{ nonconformity.checklist_item ? nonconformity.checklist_item.title : 'N/A' }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label>Observação:</label>
                                        <p>{{ nonconformity.observation }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row" v-if="nonconformity.resolution">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label>Resolução:</label>
                                        <p>{{ nonconformity.resolution }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row" >
                                <div class="col-md-12">
                                    <h3>Fotos</h3>
                                    <div class="lightBoxGallery">
                                        <div class="row">
                                            <div class="col-md-6" >
                                                <div class="ibox">
                                                    <div class="ibox-content product-box">
                                                        <div class="product-imitation">
                                                            <a :href="getPhotoUrl(nonconformity.created_photo)" target="_blank">
                                                                <img :src="getPhotoUrl(nonconformity.created_photo)" class="img-responsive" alt="Foto da não conformidade">
                                                            </a>
                                                        </div>
                                                        <div class="product-desc">
                                                            <h3>Foto da Abertura</h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-6" >
                                                <div class="ibox">
                                                    <div class="ibox-content product-box">
                                                        <div class="product-imitation">
                                                            <a :href="getPhotoUrl(nonconformity.closed_photo)" target="_blank">
                                                                <img :src="getPhotoUrl(nonconformity.closed_photo)" class="img-responsive" alt="Foto da não conformidade">
                                                            </a>
                                                        </div>
                                                        <div class="product-desc">
                                                            <h3>Foto do Fechamento</h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <!-- Modal para resolução -->
        <div class="modal fade" id="resolutionModal" tabindex="-1" role="dialog" aria-labelledby="resolutionModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="resolutionModalLabel">Resolução da Não Conformidade</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Fechar">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <label for="resolution">Descreva a resolução:</label>
                            <textarea v-model="resolution" class="form-control" id="resolution" rows="4" required></textarea>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <button type="button" class="btn btn-primary" @click="confirmClose" :disabled="!resolution.trim() || closingNonconformity">
                            <i v-if="closingNonconformity" class="fa fa-spinner fa-spin"></i>
                            Confirmar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            nonconformity: {},
            loading: true,
            closingNonconformity: false,
            error: null,
            resolution: ''
        };
    },
    created() {
        this.fetchData();
    },
    methods: {
        fetchData() {
            this.loading = true;

            const api = this.$store.state.api + 'nonconformities/' + this.$route.params.id;
            this.$http
                .get(api,{
                    params: {
                        with: ['branch', 'team', 'user', 'checklist', 'checklistItem', 'photos', 'closedBy']
                    }   
                })
                .then(response => {
                    this.nonconformity = response.data.data[0];
                    this.loading = false;
                })
                .catch(error => {
                    this.error = error;
                    this.loading = false;
                    this.$toastr.e("Erro ao carregar os dados da não conformidade.");
                });
        },
        formatDate(date) {
            if (!date) return 'N/A';
            const options = { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' };
            return new Date(date).toLocaleDateString('pt-BR', options);
        },
        getPhotoUrl(path) {
            // Extrair o nome do arquivo do caminho completo
            const filename = path.split('/').pop();
            // Usar a nova rota para acessar a foto
            const tenant = this.$store.state.tenant; // Obtém o tenant da URL atual
            const api = this.$store.state.api + 'nonconformity_photos/' + filename;
            return api;
        },
        getStatusClass(status) {
            // Implemente a lógica para determinar a classe com base no status
            // Por exemplo, você pode usar classes CSS diferentes para diferentes status
            return status === 'Fechado' ? 'text-success' : 'text-warning';
        },
        closeNonconformity() {
            // Abrir o modal para inserir a resolução
            $('#resolutionModal').modal('show');
        },
        confirmClose() {
            if (this.resolution.trim()) {
                this.closingNonconformity = true;
                const api = this.$store.state.api + `nonconformities/${this.$route.params.id}/close`;
                
                this.$http.post(api, { resolution: this.resolution })
                    .then(response => {
                        this.$toastr.s('Não conformidade fechada com sucesso!');
                        this.nonconformity = response.data.nonconformity;
                        this.closingNonconformity = false;
                    })
                    .catch(error => {
                        this.$toastr.e('Erro ao fechar a não conformidade.');
                        this.closingNonconformity = false;
                    });
            }
        }
    }
};
</script>

<style scoped>
.product-imitation {
    padding: 10px;
    text-align: center;
}

.product-imitation img {
    max-width: 100%;
    max-height: 150px;
    object-fit: cover;
}

.product-desc {
    padding: 10px;
    position: relative;
}

.lightBoxGallery {
    margin-top: 20px;
}
</style> 


// WEBPACK FOOTER //
// src/components/Nonconformity/View.vue